import axios from 'axios'

export default class TabelaDominios {
  constructor (tokenBearer, url) {
    this.url = url
    this.tokenBearer = tokenBearer
  }

  getTabelaDominios (args) {
    let url = `${this.url}/api/dominios`

    return new Promise(async (resolve, reject) => {
      let optionsDominios = {
        method: 'get',
        url: `${url}?${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }

      }

      try {
        let responseDominios = await axios(optionsDominios)
        resolve(responseDominios)
      } catch (err) {
        reject(err)
      }
    })
  }

  exportarDominios (args) {
    let url = `${this.url}/api/dominios/exportar`

    return new Promise(async (resolve, reject) => {
      let optionsDominios = {
        method: 'get',
        url: `${url}?${args}`,
        headers: {
          'Authorization': this.tokenBearer
        },
        responseType: 'blob'
      }

      try {
        let responseDominios = await axios(optionsDominios)
        resolve(responseDominios)
      } catch (err) {
        reject(err)
      }
    })
  }

  putDominio (data, tipoDominio) {
    return new Promise(async (resolve, reject) => {
      let optionsDominio = {
        method: 'put',
        url: `${this.url}/api/dominios/importar?tipoDominio=${tipoDominio}`,
        headers: {
          'Authorization': this.tokenBearer,
          'Content-Type': 'multipart/form-data'
        },
        data: data
      }

      try {
        let responseDominio = await axios(optionsDominio)
        resolve(responseDominio)
      } catch (err) {
        reject(err)
      }
    })
  }
}
